import { render, staticRenderFns } from "./trip.vue?vue&type=template&id=49c5f980&"
import script from "./trip.vue?vue&type=script&lang=js&"
export * from "./trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports